<template>
    <div class="bg-black bg-opacity-25 fixed transform transition duration-700 z-50" :class="mapViewState ? 'left-0 top-0 w-full h-full flex flex-col justify-between' : 'top-0 left-0 w-full -translate-y-full' ">
      <div id="map" class="h-screen z-10" />
      <div class="flex fixed left-0 bottom-6 w-full flex-col items-center justify-center space-y-4 px-6 mt-6 z-20">
          <default-button
            @click="$emit('closeMap', false)"
            buttonClasses=""
            text="Back"
          />
      </div>
    </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import DefaultButton from "@/components/Button.vue";

export default {
  name: "FullScreenMap",
  components: {
    DefaultButton
  },
  props: [
    'pass', 'mapViewState'
  ],
  emits: ['closeMap'],
  data() {
    return {
      loading: true,
      timer: null
    }
  },
  watch: { 
    mapViewState: function(newVal) {
      if(newVal == true) {
        // load map on inital state
        this.getMapLocation();
      }
    }
  },
  methods: {
    getMapLocation() {
      mapboxgl.accessToken =
        "pk.eyJ1IjoibWFya2xpZmVwYXNzIiwiYSI6ImNsODVwNzY0bTBycGYzb2xrank2dDRoZXgifQ.QBsVpsj8AmS56xcT3beExw";
      const map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/marklifepass/clllcporh01bx01pi7x268ay0",
        center: [this.pass[0].longitude, this.pass[0].latitude],
        zoom: 13
      });

      for(let i=0; i<this.pass.length; i++)
      {
        let name = `${this.pass[i].firstName} ${this.pass[i].lastName}`

        const marker = new mapboxgl
        .Marker({ "color": this.pass[i].color })
        .setLngLat([this.pass[i].longitude, this.pass[i].latitude])
        .setPopup(new mapboxgl.Popup({"closeButton": false, "closeOnClick": false}).setHTML(`<div style="text-align: center"><h1>${this.pass[i].deviceCode}</h1>${this.pass[i].firstName === "" ? '' : name}<div>`))
        .addTo(map)

        marker.togglePopup();
      }

      map.addControl(new mapboxgl.NavigationControl());
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true,
          showUserHeading: true
        })
      );
    }
  }
};
</script>